export default __webpack_public_path__ + "static/assets/d4d670a6e6b0dc94d23c5e4587d8709f.svg";